import { initBackgroundAnimation } from './backgroundAnimation.js'
import MicroModal from 'micromodal'
import EmblaCarousel from 'embla-carousel'
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons'
import { addDotBtnsAndClickHandlers } from './EmblaCarouselDotButtons.js'
import { projects } from '../projects.js'

initBackgroundAnimation()

function generateEmblaHTML(images) {
    const slides = images
        .map(
            (src) => `
            <div class="embla__slide">
                <img src="${src}" alt="" class="modal__image" />
            </div>
            `
        )
        .join('')
    return `
        <section class="embla">
        <div class="embla__viewport">
            <div class="embla__container">
            ${slides}
            </div>
        </div>
        <div class="embla__controls">
            <div class="embla__buttons">
            <!-- Embla carousel prev -->
            <button class="embla__button embla__button--prev" type="button">
                <svg class="embla__button__svg" viewBox="0 0 532 532">
                    <path
                        fill="currentColor"
                        d="M355.66 11.354c13.793-13.805 36.208-13.805 50.001 0 13.785 13.804 13.785 36.238 0 50.034L201.22 266l204.442 204.61c13.785 13.805 13.785 36.239 0 50.044-13.793 13.796-36.208 13.796-50.002 0a5994246.277 5994246.277 0 0 0-229.332-229.454 35.065 35.065 0 0 1-10.326-25.126c0-9.2 3.393-18.26 10.326-25.2C172.192 194.973 332.731 34.31 355.66 11.354Z"
                    ></path>
                </svg>
            </button>
            <!-- Embla carousel next -->
            <button class="embla__button embla__button--next" type="button">
                <svg class="embla__button__svg" viewBox="0 0 532 532">
                    <path
                        fill="currentColor"
                        d="M176.34 520.646c-13.793 13.805-36.208 13.805-50.001 0-13.785-13.804-13.785-36.238 0-50.034L330.78 266 126.34 61.391c-13.785-13.805-13.785-36.239 0-50.044 13.793-13.796 36.208-13.796 50.002 0 22.928 22.947 206.395 206.507 229.332 229.454a35.065 35.065 0 0 1 10.326 25.126c0 9.2-3.393 18.26-10.326 25.2-45.865 45.901-206.404 206.564-229.332 229.52Z"
                    ></path>
                </svg>
            </button>
            </div>
            <div class="embla__dots"></div>
        </div>
        </section>
        `
}

function generateProjects() {
    const listEl = document.getElementById('project-list')
    const modalsEl = document.getElementById('project-modals')

    projects.forEach((p) => {
        // 1) thumbnail
        const li = document.createElement('li')
        const a = document.createElement('a')
        a.setAttribute('data-micromodal-trigger', p.id)
        const img = document.createElement('img')
        img.src = p.thumbnail
        img.alt = p.descriptions[0].slice(0, 80)
        a.appendChild(img)
        li.appendChild(a)
        listEl.appendChild(li)

        // 2) modal
        const modal = document.createElement('div')
        modal.className = 'modal micromodal-slide'
        modal.id = p.id
        modal.setAttribute('aria-hidden', 'true')

        // inner HTML
        modal.innerHTML = `
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
            <div class="modal__container" role="dialog" aria-modal="true">
            ${
                p.images.length > 1
                    ? generateEmblaHTML(p.images)
                    : `<img src="${p.images[0]}" alt="" class="modal__image" />`
            }
            <div class="modal__content-wrapper">
                ${
                    Array.isArray(p.descriptions)
                        ? p.descriptions.map((d) => `<p>${d}</p>`).join('')
                        : `<p>${p.description}</p>`
                }
                <p>${p.tech}</p>
                <ul>
                ${
                    Array.isArray(p.links) && p.links.length
                        ? p.links
                              .map(
                                  (link) => `
                                    <li>
                                        <a href="${link.url}" target="_blank">
                                        <button class="modal__btn">${link.text}</button>
                                        </a>
                                    </li>
                                    `
                              )
                              .join('')
                        : ''
                }
                </ul>

            </div>
            <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
            <footer class="modal-footer"><div class="modal-footer-accent"></div></footer>
            </div>
        </div>
        `

        modalsEl.appendChild(modal)
    })
}

generateProjects()

/**
 * Initializes the MicroModal library for modal dialogs.
 */

MicroModal.init({ awaitCloseAnimation: true, disableFocus: true, disableScroll: true })

const OPTIONS = { loop: true }

// A helper to initialize one Embla instance + its controls
function initEmblaCarousel(emblaNode) {
    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev')
    const nextBtnNode = emblaNode.querySelector('.embla__button--next')
    const dotsNode = emblaNode.querySelector('.embla__dots')

    // 1) Create the Embla instance
    const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

    // 2) Wire up prev/next buttons
    const removePrevNext = addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode)

    // 3) Wire up dot buttons
    const removeDotHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode)

    // 4) Clean up when Embla is destroyed
    emblaApi.on('destroy', () => {
        removePrevNext()
        removeDotHandlers()
    })

    return emblaApi
}

// Find *every* carousel on the page and init it
document.querySelectorAll('.embla').forEach(initEmblaCarousel)
